export default __webpack_public_path__ + "static/media/spark_86.d6cdbff2.png";